interface HasRef {
  ref: string
}

export function removeAllRefsFromItems<T extends HasRef>(items: Array<T>): Array<T> {
  return items.map((item) => ({ ...item, ref: "" }))
}

export type RefType = "sku" | "option" | "deal"

export const REF_PREFIXES: Record<RefType, string> = {
  sku: "HUB-",
  option: "HUBOPT-",
  deal: "HUBDEAL-",
}

export type GenerateRefsOptions = {
  replaceExisting: boolean
}

export function generateRefsForItems<T extends HasRef>(
  items: Array<T>,
  options: GenerateRefsOptions,
  type: RefType,
  counter = { value: 1 },
): Array<T> {
  const prefix = REF_PREFIXES[type]
  return items.map((item) => {
    if (item.ref !== "" && !options.replaceExisting) {
      return item
    }
    return { ...item, ref: `${prefix}${counter.value++}` }
  })
}
